import enumFactory from "@/util/enumFactory";

export default enumFactory.createEnum({

    FIRST_PROPORTION: {
        code: 5,
        title: '一级分销'
    },
    SECOND_PROPORTION: {
        code: 6,
        title: '二级分销'
    }

});
